.sn-key-features-type-1 {
  display: flex;
  flex-direction: column;
  gap: map-get($spacings, 2xl);

  @include above($breakpoint-desktop-md) {
    gap: map-get($spacings, 3xl);
  }

  &__header {
    display: flex;
    flex-direction: column;

    .me-text {
      @include above($breakpoint-desktop-md) {
        max-width: calc(100% * 8 / 12);
      }
    }
  }

  &__grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: map-get($spacings, md);

    @include above($breakpoint-desktop) {
      grid-template-columns: repeat(2, 1fr);
      gap: map-get($spacings, xl);
    }

    @include above($breakpoint-desktop-md) {
      grid-template-columns: repeat(3, 1fr);
      gap: map-get($spacings, 2xl);
    }
  }

  &__card {
    display: flex;
    flex-direction: column;
    background-color: var(--background-color-secondary);
    border-radius: var(--radius-size-lg);
    padding: map-get($spacings, lg);

    @include above($breakpoint-desktop) {
      padding: map-get($spacings, xl);
    }

    @include above($breakpoint-desktop-md) {
      padding: map-get($spacings, 2xl);
    }
  }

  &__card-title {
    font-weight: 700;
    font-size: map-get($font-sizes, lg);
    line-height: map-get($line-heights, md);
    color: var(--color-text-primary);
    margin: 0;
    margin-bottom: map-get($spacings, xs);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }

    @include above($breakpoint-desktop-md) {
      font-size: map-get($font-sizes, 2xl);
      line-height: map-get($line-heights, 2xl);
    }

    .me-heading {
      margin-bottom: 0;
    }
  }

  &__card-text {
    font-weight: 400;
    color: var(--color-text-primary);
    margin: 0;

    p.me-text {
      font-size: map-get($font-sizes, md);
      line-height: map-get($line-heights, lg);
    }
  }

  .me-heading--4 {
    font-size: map-get($font-sizes, 2xl);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, 3xl);
    }

    @include above($breakpoint-desktop-md) {
      font-size: map-get($font-sizes, 4xl);
    }
  }

  .me-heading--6 {
    font-size: 24px;
    line-height: 32px;
  }

  .me-text {
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }
  }
}
